import React from 'react'
import PropTypes from 'prop-types'
import { getIcon } from '@helpers/image'
import classNames from 'classnames'

const Icon = props => {
    const {
        icon,
        rotate,
        color = undefined,
        iconClasses,
    } = props

    const classes = classNames(color)
    const IconComponent = getIcon(icon)

    return (
      <div className={classes} style={{ transform: `rotate(${rotate}deg)` }}>
        <IconComponent classes={iconClasses} />
      </div>
    )
}

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    rotate: PropTypes.number,
    color: PropTypes.string,
    iconClasses: PropTypes.string,
}

export default Icon
